import {
  THREAT_HUNTING_FIELDS_SET,
  THREAT_HUNTING_FIELDS_REQ,
  THREAT_HUNTING_FIELDS_SUCCESS,
  THREAT_HUNTING_FIELDS_ERROR,
  THREAT_HUNTING_FIELDS_RESET_STATUS,
  THREAT_HUNTING_EVENT_TYPES_SET,
  THREAT_HUNTING_EVENT_TYPES_REQ,
  THREAT_HUNTING_EVENT_TYPES_SUCCESS,
  THREAT_HUNTING_EVENT_TYPES_ERROR,
  THREAT_HUNTING_EVENT_TYPES_RESET_STATUS
} from './query-fields.type'

import ApiRest from '@/api/api-rest'

const state = {
  threatHuntingEventTypesReqStatus: '',
  threatHuntingEventTypes: {},
  threatHuntingQueryFieldsReqStatus: '',
  threatHuntingQueryFields: {}
}

const getters = {
  threatHuntingEventTypesReqStatus: state => state.threatHuntingEventTypesReqStatus,
  threatHuntingEventTypes: state => state.threatHuntingEventTypes,
  threatHuntingQueryFieldsReqStatus: state => state.threatHuntingQueryFieldsReqStatus,
  threatHuntingQueryFields: state => state.threatHuntingQueryFields
}

const mutations = {
  [THREAT_HUNTING_FIELDS_SET]: (state, data) => {
    state.threatHuntingQueryFields = data
  },
  [THREAT_HUNTING_FIELDS_REQ]: state => {
    state.threatHuntingQueryFieldsReqStatus = 'loading'
  },
  [THREAT_HUNTING_FIELDS_SUCCESS]: state => {
    state.threatHuntingQueryFieldsReqStatus = 'saved'
  },
  [THREAT_HUNTING_FIELDS_ERROR]: state => {
    state.threatHuntingQueryFieldsReqStatus = 'error'
  },
  [THREAT_HUNTING_FIELDS_RESET_STATUS]: state => {
    state.threatHuntingQueryFieldsReqStatus = ''
  },
  [THREAT_HUNTING_EVENT_TYPES_SET]: (state, data) => {
    state.threatHuntingEventTypes = data
  },
  [THREAT_HUNTING_EVENT_TYPES_REQ]: state => {
    state.threatHuntingEventTypesReqStatus = 'loading'
  },
  [THREAT_HUNTING_EVENT_TYPES_SUCCESS]: state => {
    state.threatHuntingEventTypesReqStatus = 'saved'
  },
  [THREAT_HUNTING_EVENT_TYPES_ERROR]: state => {
    state.threatHuntingEventTypesReqStatus = 'error'
  },
  [THREAT_HUNTING_EVENT_TYPES_RESET_STATUS]: state => {
    state.threatHuntingEventTypesReqStatus = ''
  }
}

const actions = {
  [THREAT_HUNTING_FIELDS_REQ] (context) {
    return new Promise((resolve, reject) => {
      context.commit(THREAT_HUNTING_FIELDS_REQ)
      ApiRest()
        .get('/bi/searchquery/fields')
        .then(({ data }) => {
          if (context.rootState.agents.agentList.models) {
            let hostFitlerIdx = _.findIndex(data, { name: 'host' })
            if (hostFitlerIdx > -1) {
              let agentIdFitlerIdx = _.findIndex(data[hostFitlerIdx].fields, {
                name: 'agentId'
              })
              data[hostFitlerIdx].fields[agentIdFitlerIdx].datatype = 'select'
              data[hostFitlerIdx].fields[agentIdFitlerIdx].values = _.map(
                context.rootState.agents.agentList.models,
                agent => {
                  return { label: agent.customHostname, value: agent.agentId }
                }
              )
            }
          }

          context.commit(THREAT_HUNTING_FIELDS_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(THREAT_HUNTING_FIELDS_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [THREAT_HUNTING_FIELDS_SUCCESS] (context) {
    context.commit(THREAT_HUNTING_FIELDS_SUCCESS)
  },
  [THREAT_HUNTING_FIELDS_RESET_STATUS] (context) {
    context.commit(THREAT_HUNTING_FIELDS_RESET_STATUS)
  },
  [THREAT_HUNTING_EVENT_TYPES_REQ] (context) {
    return new Promise((resolve, reject) => {
      context.commit(THREAT_HUNTING_EVENT_TYPES_REQ)
      ApiRest()
        .get('/bi/searchquery/event-types')
        .then(({ data }) => {
          for (let idx in data) {
            for (let eventType of data[idx].values) {
              eventType.parentClass = data[idx].value
            }
          }
          context.commit(THREAT_HUNTING_EVENT_TYPES_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(THREAT_HUNTING_EVENT_TYPES_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [THREAT_HUNTING_EVENT_TYPES_SUCCESS] (context) {
    context.commit(THREAT_HUNTING_EVENT_TYPES_SUCCESS)
  },
  [THREAT_HUNTING_EVENT_TYPES_RESET_STATUS] (context) {
    context.commit(THREAT_HUNTING_EVENT_TYPES_RESET_STATUS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/threat_hunting/query-fields.module.js